import { useState, useEffect } from 'react';

type UseAutoRotateProps = {
  length: number;
  interval?: number;
  onNext: () => void;
};

export function useAutoRotate({
  length,
  interval = 5000,
  onNext
}: UseAutoRotateProps) {
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (length <= 1 || isPaused) return;

    const intervalId = setInterval(() => {
      onNext();
    }, interval);

    return () => clearInterval(intervalId);
  }, [length, interval, isPaused, onNext]);

  // pause on hover/focus
  const containerProps = {
    onMouseEnter: () => setIsPaused(true),
    onMouseLeave: () => setIsPaused(false),
    onFocus: () => setIsPaused(true),
    onBlur: () => setIsPaused(false)
  };

  return { isPaused, containerProps };
}
